module.exports = __webpack_public_path__ + "static/media/vivian_wong.f8b36a68.png";